import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const VisualCommunication = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="84" viewBox="0 0 77 84" width="77" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M68.75 33.4H12.72a2.9 2.9 0 0 0-2.9 2.89V75.6c0 1.6 1.3 2.9 2.9 2.9h56.03c1.6 0 2.9-1.3 2.9-2.9V36.3c0-1.6-1.3-2.9-2.9-2.9Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M63.72 27.3H7.68a2.9 2.9 0 0 0-2.9 2.9v39.32c0 1.6 1.3 2.9 2.9 2.9h56.04c1.6 0 2.9-1.3 2.9-2.9V30.2c0-1.6-1.3-2.9-2.9-2.9Zm-4.9 36.44c0 .45-.4.85-.88.85H13.46c-.47 0-.88-.41-.88-.85V35.97a.9.9 0 0 1 .88-.88h44.47a.9.9 0 0 1 .88.88z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M58.82 35.97v27.77c0 .45-.4.85-.88.85H13.46c-.47 0-.88-.41-.88-.85V35.97a.9.9 0 0 1 .88-.88h44.47a.9.9 0 0 1 .88.88z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m29.13 27.29 7.75-19.02 7 19.02" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M36.88 11.3a3.03 3.03 0 1 0 0-6.06 3.03 3.03 0 0 0 0 6.05Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path d="M45.03 43.35v12.3h-6.15v-6.16h-6.14v6.15H26.6v-12.3z" fill={shades.black} />
    </svg>
  );
};
